import React from "react";
import { useTranslation } from "react-i18next";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import "./contractors.css";
import BannerComponent from "../../components/bannerComponent/bannerComponent";
import ButtonLinkComponent from "../../components/buttonLink/buttonLink";

const Contractors = () => {
  const { t } = useTranslation();

  const heroData = {
    chipText: t("CONTRACTING_MAIN_CHIP"),
    title: t("CONTRACTING_MAIN_COMPREHENSIVE_CONSULTING"),
    text: t("CONTRACTING_MAIN_AT_5IG_SOLUTIONS"),
    button: t("BOOK_APPOINTMENT_BUTTON"),
    className: "consulting",
    url: "https://outlook.office365.com/book/G07e86683359a41f58322cab8b2047723@5igsolutions.com/?RefID=CONSULTING",
  };

 const whyChooseUsData = [
  {
    title: t("CONTRACTING_MAIN_EXPERIENCE_AND_EXPERTISE"),
    text: t("CONTRACTING_MAIN_EXPERIENCE_AND_EXPERTISE_TEXT"),
    icon: "strategic_consulting.svg",
    imgSrc: "/img/openart-image_2AkErhgH_1715873940524_raw 2.jpg",
  },
  {
    title: t("CONTRACTING_MAIN_STRATEGIC_FOCUS"),
    text: t("CONTRACTING_MAIN_STRATEGIC_FOCUS_TEXT"),
    icon: "focus_growth.svg",
    imgSrc: "/img/tailor solutions 1.jpg",
  },
  {
    title: t("CONTRACTING_MAIN_CUSTOMIZED_SOLUTIONS"),
    text: t("CONTRACTING_MAIN_CUSTOMIZED_SOLUTIONS_TEXT"),
    icon: "digital_transformation.svg",
    imgSrc: "/img/medium-shot-people-working-as-real-estate-agents 3.jpg",
  },
  {
    title: t("CONTRACTING_MAIN_PROCESS_OPTIMIZATION"),
    text: t("CONTRACTING_MAIN_PROCESS_OPTIMIZATION_TEXT"),
    icon: "process_auditing.svg",
    imgSrc: "/img/tailor solutions 2.jpg",
  },
];

  const servicePillars = [
    {
        title: "Gestión administrativa, operativa y financiera",
        icon: "administrative_management.svg",
        items: [
        t("CONTRACTING_MAIN_BPO"),
        t("CONTRACTING_MAIN_RECORDS_MANAGEMENT"),
        t("CONTRACTING_MAIN_AUTOMATION_OF_REPETITIVE_PROCESSES"),
        t("CONTRACTING_MAIN_ACCOUNTING_AND_FINANCIAL_MANAGEMENT"),
        t("CONTRACTING_MAIN_PAYROLL_AND_HUMAN_RESOURCES_MANAGEMENT"),
        ],
    },
    {
        title: "Cumplimiento, seguridad y auditoría",
        icon: "regulatory_compliance.svg",
        items: [
        t("CONTRACTING_MAIN_DESIGN_AND_IMPLEMENTATION_OF_HEALTH_AND_SAFETY_PROGRAMS"),
        t("CONTRACTING_MAIN_RISK_ASSESSMENT_AND_TRAINING"),
        t("CONTRACTING_MAIN_CYBERSECURITY_CONSULTING"),
        t("CONTRACTING_MAIN_MONITORING_AND_INCIDENT_RESPONSE"),
        t("CONTRACTING_MAIN_COMPREHENSIVE_PROCESS_REVIEW"),
        t("CONTRACTING_MAIN_IMPLEMENTATION_OF_IMPROVEMENTS"),
        t("CONTRACTING_MAIN_LEGAL_AND_TAX_ADVISORY"),
        t("CONTRACTING_MAIN_AUDIT_AND_COMPLIANCE"),
        ],
    },
    {
        title: "Infraestructura, transformación y crecimiento",
        icon: "strategic_consulting.svg",
        items: [
        t("CONTRACTING_MAIN_IT_INFRASTRUCTURE_MANAGEMENT_AND_MAINTENANCE"),
        t("CONTRACTING_MAIN_TECHNICAL_SUPPORT_AND_EQUIPMENT_UPGRADES"),
        t("CONTRACTING_MAIN_ERP_IMPLEMENTATION"),
        t("CONTRACTING_MAIN_PROCESS_AUTOMATION_AND_CYBERSECURITY"),
        t("CONTRACTING_MAIN_STRATEGIC_PLANNING"),
        t("CONTRACTING_MAIN_MARKET_AND_COMPETITOR_ANALYSIS"),
        ],
    },
    ];

  const growthCards = [
    {
      title: t("CONTRACTING_MAIN_TIME_AND_RESOURCE_SAVINGS"),
      text: t("CONTRACTING_MAIN_TIME_AND_RESOURCE_SAVINGS_DESCRIPTION"),
      img: "time_resource.svg",
    },
    {
      title: t("CONTRACTING_MAIN_INCREASED_EFFICIENCY"),
      text: t("CONTRACTING_MAIN_INCREASED_EFFICIENCY_DESCRIPTION"),
      img: "increased_efficiency.svg",
    },
    {
      title: t("CONTRACTING_MAIN_LEGAL_COMPLIANCE_AND_PEACE_OF_MIND"),
      text: t("CONTRACTING_MAIN_LEGAL_COMPLIANCE_AND_PEACE_OF_MIND_DESCRIPTION"),
      img: "legal_peace.svg",
    },
    {
      title: t("CONTRACTING_MAIN_FOCUS_ON_GROWTH"),
      text: t("CONTRACTING_MAIN_FOCUS_ON_GROWTH_DESCRIPTION"),
      img: "focus_growth.svg",
    },
  ];

 function WhyItem({ icon, title, text, imgSrc}) {
  return (
    <article className="contractorsWhyItem">
      <div className="contractorsWhyItemContent">
        <div className="contractorsWhyIcon">
          <img src={`/img/${icon}`} alt="" />
        </div>
        <h3>{title}</h3>
        <p>{text}</p>
      </div>

      <div className="contractorsWhyItemMedia">
        <img src={imgSrc} alt={title} />
      </div>
    </article>
  );
}

  function PillarCard({ icon, title, items }) {
    return (
      <article className="contractorsPillarCard">
        <div className="contractorsPillarIcon">
          <img src={`/img/${icon}`} alt="" />
        </div>
        <h3>{title}</h3>
        <ul>
          {items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </article>
    );
  }

  function GrowthCard({ img, title, text }) {
    return (
      <article className="contractorsGrowthCard">
        <div className="contractorsGrowthIcon">
          {img && <img src={`/img/${img}`} alt="" />}
        </div>
        <h3>{title}</h3>
        <p>{text}</p>
      </article>
    );
  }

  return (
    <>
      <Header />

      <main className="contractorsPage">
        <section className="contractorsHero contractorsHeroFull">
          <div className="contractorsHeroBanner contractorsHeroBannerFull">
            <BannerComponent
              chipText={heroData.chipText}
              translateTitle={heroData.title}
              translateText={heroData.text}
              translateButton={heroData.button}
              className={heroData.className}
              classNameSide="l"
              url={heroData.url}
              featured={true}
              headingTag="h1"
            />
          </div>
        </section>

        <section className="contractorsWhy">
          <div className="contractorsWhyWrap">
            <div className="contractorsSectionIntro contractorsSectionIntroCompact">
              <h2>{t("CONTRACTING_MAIN_WHY_CHOOSE_US")}</h2>
              <p>{t("CONTRACTING_MAIN_AT_5IG_SOLUTIONS")}</p>
            </div>

            <div className="contractorsWhyGridCompact">
                {whyChooseUsData.map((item) => (
                    <WhyItem
                    key={item.title}
                    title={item.title}
                    text={item.text}
                    icon={item.icon}
                    imgSrc={item.imgSrc}
                    />
                ))}
            </div>
          </div>
        </section>

        <section className="contractorsServices">
          <div className="contractorsSectionIntro">
            <h2>{t("CONTRACTING_MAIN_OUR_CONSULTING_SERVICES")}</h2>
          </div>

          <div className="contractorsPillarsGrid">
            {servicePillars.map((pillar) => (
              <PillarCard
                key={pillar.title}
                title={pillar.title}
                items={pillar.items}
                icon={pillar.icon}
              />
            ))}
          </div>
        </section>

        <section className="contractorsGrowth">
          <div className="contractorsSectionIntro">
            <h2>{t("CONTRACTING_MAIN_FOCUS_ON_GROWTH")}</h2>
          </div>

          <div className="contractorsGrowthGrid">
            {growthCards.map((card, index) => (
              <GrowthCard
                key={index}
                title={card.title}
                text={card.text}
                img={card.img}
              />
            ))}
          </div>
        </section>

        <section className="contractorsCta">
          <div className="contractorsCtaInner">
            <h2>{t("CONTRACTING_MAIN_COMPREHENSIVE_CONSULTING")}</h2>

            <ButtonLinkComponent
              translateButton="BOOK_APPOINTMENT_BUTTON"
              url="https://outlook.office365.com/book/G07e86683359a41f58322cab8b2047723@5igsolutions.com/?RefID=CONSULTING"
              blank={true}
              className="buttonContactContractors"
            />
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default Contractors;